import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MODAL_ACTIONS_CLEAR } from 'store/modules/ModalsActionTypes';
import { IModalsReducer } from 'store/modules/ModalsReducer';
import { IReducer } from 'store/Reducer';

export interface IModalsManager {
  modals: IModalsReducer;
}

export default function ModalsManager() {
  const modals = useSelector((state: IReducer) => state.modals);
  const dispatch = useDispatch();

  useEffect(() => {
    modals.modals.forEach((m) => {
      if (!m.componentProps?.open) {
        setTimeout(() => {
          dispatch({ type: MODAL_ACTIONS_CLEAR, payload: m.key });
        }, 300);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modals]);

  return (
    <Fragment>
      {Array.from(modals.modals.values()).map((modal, index) => {
        const Component: any = modal.component;
        const modalProps = {
          ...modal.componentProps,
          modalKey: modal.key,
          key: index,
        };
        return <Component {...modalProps} />;
      })}
    </Fragment>
  );
}
